import React, { useState, useEffect } from "react";
import "./Scorecard.css";
import ScorecardTable from "./ScorecardTable";

const Scorecard = React.memo(({ clubData, selectedHole, setSelectedHole, unit }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [selectedTee, setSelectedTee] = useState(
    clubData.holes[0].tees[0].name
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 500);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="scorecard-container">
      <div className="glfr-sc-scorecard-section">
        <ScorecardTable
          holes={clubData.holes}
          selectedHole={selectedHole}
          onHoleClick={setSelectedHole}
          unit={unit}
          isMobile={isMobile}
          selectedTee={selectedTee}
          onTeeChange={setSelectedTee}
        />
      </div>
    </div>
  );
});

Scorecard.displayName = 'Scorecard';

export default Scorecard;
